module.exports = __webpack_public_path__ + "img/11ne.2a043a3e.svg";